// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"f4e55a7a","529":"724f6d17","895":"ecee3f95"}[chunkId] + ".chunk.css";
};